<template>
  <form class="row" @submit.prevent="submitHandle">
    <div class="col-md-12">
      <div class="panel panel-default">
        <div class="panel-heading">
          <h3 class="panel-title">Generale</h3>
        </div>
        <div class="panel-body">
          <div class="row">
            <input-text name="title" label="Titolo" required :readonly="isShow" v-model="formData.title"></input-text>

            <input-textarea name="description" label="Descrizione" required :readonly="isShow" v-model="formData.description"></input-textarea>

            <input-image name="image" label="Immagine" :disabled="isShow" required :url="formData.image" v-model="formData.image"></input-image>

            <input-radio
              name="enabled"
              width="6"
              label="Stato"
              :options="[
                { value: '1', label: 'Attivo' },
                { value: '0', label: 'Disattivo' },
              ]"
              required
              :disabled="isShow"
              v-model="formData.enabled"
            ></input-radio>

            <input-radio
              name="highlighted"
              width="6"
              label="In evidenza"
              :options="[
                { value: '0', label: 'No' },
                { value: '1', label: 'Si' },
              ]"
              required
              :disabled="isShow"
              v-model="formData.highlighted"
            ></input-radio>
          </div>

          <div class="row">
            <input-select name="segment_id" width="6" label="Segmento" :options="segmentOptions" :disabled="isShow" v-model="formData.segment_id"></input-select>

            <input-select-multiple name="brand" width="6" label="Brand" :options="brandOptions" required :disabled="isShow" v-model="formData.brand"></input-select-multiple>
          </div>

          <div class="row">
            <input-date-picker name="visibility_start" width="6" label="Data di pubblicazione" required :disabled="isShow" v-model="formData.visibility_start"></input-date-picker>

            <input-date-picker name="visibility_end" width="6" label="Data di fine compilazione" required :disabled="isShow" v-model="formData.visibility_end"></input-date-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <h3>Domande e risposte</h3>
      <div class="questions-container">
        <question-row
          v-for="(question, index) in questions"
          :index="index"
          :key="index"
          :question="question"
          :question-types-options="questionTypesOptions"
          :tags-options="tagsOptions"
          :mft-attributes-options="mftAttributesOptions"
          :profile-attributes-options="profileAttributesOptions"
          :isShow="isShow || lockEditAnswers"
          @add-answer="addAnswerHandler(index)"
          @remove-answer="(answerIndex) => removeAnswerHandler(answerIndex, index)"
          @remove-question="removeQuestionHandler(index)"
          @add-tag-value="(answerIndex) => addTagValue(answerIndex, index)"
          @remove-tag-value="(answerIndex, tagValueIndex) => removeTagValue(answerIndex, tagValueIndex, index)"
        ></question-row>

        <div class="row" v-if="!isShow && !lockEditAnswers">
          <div class="col-md-12">
            <button type="button" class="btn btn-sm btn-primary" @click="addQuestionHandler">Aggiungi domanda</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isShow" class="col-md-12 text-right">
      <button class="btn btn-success" :disabled="questions.length === 0">Salva</button>
    </div>
  </form>
</template>

<script>
import { toFormData, toSelectOptions } from '../helpers';

export default {
  props: {
    type: {
      type: 'create' | 'edit' | 'show',
      default: 'create',
    },
    id: {
      type: Number,
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
    brands: {
      type: Object,
      default: {},
    },
    segments: {
      type: Object,
      default: {},
    },
    questionsData: {
      type: Array,
      default: () => [],
    },
    tags: {
      type: Object,
      default: () => [],
    },
    questionTypes: {
      type: Array,
      default: () => [],
    },
    mftAttributes: {
      type: Object,
      default: () => [],
    },
    profileAttributes: {
      type: Object,
      default: () => [],
    },
    lockEditAnswers: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        title: '',
        description: '',
        enabled: '',
        segment_id: '',
        brand: [],
        highlighted: '',
        visibility_start: '',
        visibility_end: '',
        image: null,
      },
      questions: [],
      brandOptions: [],
      segmentOptions: [],
    };
  },
  methods: {
    addQuestionHandler() {
      this.questions.push({
        title: '',
        description: '',
        type: '0',
        mft_attribute: '',
        profile_attribute: '',
        answers: [
          {
            text: '',
            tagValues: [{ tag: '', value: '' }],
          },
        ],
        multiple_answer: false,
      });
    },
    removeQuestionHandler(questionIndex) {
      this.questions.splice(questionIndex, 1);
    },
    addAnswerHandler(questionIndex) {
      this.questions[questionIndex].answers.push({ text: '', tagValues: [{ tag: '', value: '' }] });
    },
    removeAnswerHandler(answerIndex, questionIndex) {
      this.questions[questionIndex].answers.splice(answerIndex, 1);
    },
    addTagValue(answerIndex, questionIndex) {
      this.questions[questionIndex].answers[answerIndex].tagValues.push({ tag: '', value: '' });
    },
    removeTagValue(answerIndex, tagValueIndex, questionIndex) {
      this.questions[questionIndex].answers[answerIndex].tagValues.splice(tagValueIndex, 1);
    },

    submitHandle() {
      const formData = toFormData(this.formData);

      this.questions.forEach((question, index) => {
        formData.append(`questions[${index}][title]`, question.title);
        formData.append(`questions[${index}][description]`, question.description);
        formData.append(`questions[${index}][type]`, question.type);

        // Append MFT attribute if the question type is 2
        if (question.type == 2) {
          formData.append(`questions[${index}][mft_attribute]`, question.mft_attribute);
        }

        // Append Profile attribute if the question type is 3
        if (question.type == 3) {
          formData.append(`questions[${index}][profile_attribute]`, question.profile_attribute);
        } else {
          formData.append(`questions[${index}][multiple_answer]`, question.multiple_answer);
          question.answers.forEach((answer, answerIndex) => {
            formData.append(`questions[${index}][answers][${answerIndex}][text]`, answer.text);

            // Append tag values if the question type is 1
            if (question.type == 1) {
              answer.tagValues.forEach((tagValue, tagValueIndex) => {
                formData.append(`questions[${index}][answers][${answerIndex}][tagValues][${tagValueIndex}][tag]`, tagValue.tag);
                formData.append(`questions[${index}][answers][${answerIndex}][tagValues][${tagValueIndex}][value]`, tagValue.value);
              });
            }
          });
        }
      });

      if (this.type === 'edit') {
        formData.append('_method', 'PUT');
      }

      axios[this.apiMethod](this.apiEndpoint, formData)
        .then((response) => {
          Swal.fire({
            icon: 'success',
            title: 'Complimenti',
            text: this.successMessage,
            allowOutsideClick: false,
          }).then(function(result) {
            if (result.isConfirmed) {
              window.location.href = `/surveys/${response.data.data.id}`;
            }
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.response.data.message || 'Qualcosa è andato storto!',
          });
        });
    },
  },
  computed: {
    isShow() {
      return this.type === 'show';
    },
    apiEndpoint() {
      return this.type === 'edit' ? `/surveys/${this.id}` : '/surveys';
    },
    apiMethod() {
      return 'post';
    },
    successMessage() {
      return this.type === 'edit' ? 'Il sondaggio è stato aggiornato correttamente' : 'Il sondaggio è stato creato correttamente';
    },
  },
  mounted() {
    if (this.segments) this.segmentOptions = toSelectOptions(this.segments);
    if (this.brands) this.brandOptions = toSelectOptions(this.brands);
    if (this.tags) this.tagsOptions = toSelectOptions(this.tags);
    if (this.questionTypes) this.questionTypesOptions = toSelectOptions(this.questionTypes);
    if (this.mftAttributes) this.mftAttributesOptions = toSelectOptions(this.mftAttributes);
    if (this.profileAttributes) this.profileAttributesOptions = toSelectOptions(this.profileAttributes);

    if (this.questionsData) {
      this.questions = this.questionsData.map((question) => ({
        ...question,
        answers: question.answers.map((answer) => ({
          text: answer.text,
          tagValues: answer.tagValues.map(({ tag, value }) => ({ tag, value })),
        })),
      }));
    }

    if (this.data) {
      this.formData = { ...this.data };
    }
  },
};
</script>

<style scoped>
.questions-container {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/surveyManagment.vue